module.exports = __webpack_public_path__ + "static/media/gal.a7e8bfed.png";